<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
    <div v-loading="nalaganjeZaporeKlicev">
      <div style="padding-bottom: 30px;">
        <div>
          <p class="navadno-besedilo">
            Za brezskrbno uporabo omogočamo številne nastavitve mobilne telefonije, s katerimi imate nadzor
            nad porabo storitev. <br> Preverite tudi koristne informacije o uporabi podatkovnega prometa v
            <a :href="nadzorPorabeMobilneTelefonije" class="primarna-barva">
              tujini
            </a>.
          </p>
        </div>
        <div style="padding-top: 20px" v-if="!jeMobilniTopPaket">
          <div>
            <p class="open-sans-20pt">
              Blokade mobilnega interneta
            </p>
          </div>
        </div>
        <div style="padding-top: 30px" v-if="!jeMobilniTopPaket">
          <p class="navadno-besedilo">
            Omejitev prenosa podatkov omogoča, da sistem samodejno blokira podatkovni promet ob doseženi
            porabi 61 € na podatkovnem prenosu. <br v-if="formaOrientacija === 'left'">
            Izbirna meja podatkovnega prenosa v slovenskih omrežjih pomeni, da se podatkovni prenos blokira,
            ko poraba izven zakupljenih enot preseže izbrano vrednost meje. <br v-if="formaOrientacija === 'left'">
            Vrednost meje je izražena v EUR z DDV.
          </p>
        </div>
        <div style="clear: both; padding-top: 30px" v-loading="jePridobivanjePodatkovneBlokade" v-if="!jeMobilniTopPaket">
          <el-form label-width="400px" :label-position="formaOrientacija">
            <el-form-item label="Omejitev prenosa podatkov">
              <el-select v-model="izbranaMednarodnoPodatkovneBlokade.idUmtsOmejitevSifrant"
                         placeholder="Izberite"
                         class="velikost-izbirnika-prenosa"
                         @change="SpremebaMednarodnoPodatkovneBlokade">
                <el-option
                    v-for="omejitev in mednarodnoPodatkovneBlokade"
                    :label="omejitev.naziv"
                    :key="omejitev.naziv"
                    :value="omejitev.idUmtsOmejitevSifrant">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Meje podatkovnega prenosa v slovenskih omrežjih">
              <el-select placeholder="Izberite"
                         v-model="izbranaNacionalnaPodatkovnaBlokada.value"
                         class="velikost-izbirnika-prenosa"
                         @change="SpremebaNacionalnePodatkovneBlokade">
                <el-option
                    v-for="meje in nacionalnePodatkovneBlokade"
                    :label="meje.name"
                    :key="meje.name"
                    :value="meje.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="voiceFeaturesEnabled">
        <hr class="hr-stil" v-if="!jeMobilniTopPaket">
        <div class="odmik-locenih-vsebin">
          <div>
            <div>
              <p class="open-sans-20pt">
                Blokada komercialnih sporočil
              </p>
            </div>
          </div>
          <div class="odmik-statusa-blokade-komercialnih-sporocil">
            <b>STATUS:</b>
            <span v-if="prenosniPodatkiKomercialnaSporocila.blokirano == false">
            Nimate blokiranih komercialnih sporočil.
          </span>
            <span v-else>
            Imate blokirana komercialna sporočila.
          </span>
          </div>
          <div class="postavitev-gumb" v-if="prenosniPodatkiKomercialnaSporocila.blokirano == false">
            <el-button type="primary" class="gumb-potrdi" @click="NastaviBlokado">
              NASTAVI BLOKADO
            </el-button>
          </div>
          <div class="postavitev-gumb" v-else>
            <el-button type="primary" class="gumb-potrdi" @click="OdstraniBlokado">
              ODSTRANI BLOKADO
            </el-button>
          </div>
          <div class="odmik-zgodovine-komercialnih-sporocil" v-if="seznamPodatkovZgodovineSporocil.length !== 0">
            <div class="open-sans-17pt">
              Zgodovina blokade komercialnih sporočil
            </div>
            <div style="padding-top: 10px">
              <el-table
                :data="seznamPodatkovZgodovineSporocil">
                <el-table-column
                  label="Datum od"
                  prop="datum_od">
                </el-table-column>
                <el-table-column
                  label="Datum do"
                  prop="datum_do">
                </el-table-column>
                <el-table-column
                  label="Opomba"
                  prop="opomba">
                </el-table-column>
              </el-table>
              <div class="text-center" style="cursor: pointer;">
                <el-pagination
                  @current-change="PrikaziStranZgodovineKomercialnihSporocil"
                  :hide-on-single-page="true"
                  :page-size="4"
                  layout="prev, pager, next"
                  :total="dolzinaZgodovineKomercialnihSporocil"
                  small>
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="hr-stil">
      <div class="odmik-locenih-vsebin">
        <div>
          <div>
            <p class="open-sans-20pt">
              Omrežje, v katerem želite uporabljati podatke
            </p>
          </div>
        </div>
        <div style="padding-top: 30px">
          <p class="navadno-besedilo">
            Izberite želene kombinacije omrežij, v katerih želite uporabljati prenos podatkov. <br>
            Preverite cenik gostovanja v tujih omrežjih na
            <a :href="mobilnoGostovanje" class="primarna-barva" target="_blank">
              https://www.t-2.net/mobilno-gostovanje
            </a>
          </p>
        </div>
        <div v-if="seznamRoamingProfilov.length > 0">
          <div class="postavitev-roaming-profili">
            <div v-for="(profil) in seznamRoamingProfilov">
              <div>
                <span>
                  <el-checkbox v-if="vklopljenOperaterskiRoamingProfil" :disabled="true"
                               v-model="profil.vklopljenOperatersko"
                               @change="GetInfoKolikoJeOzancenih(profil.idProfil)">
                  </el-checkbox>
                  <el-checkbox v-else v-model="profil.vklopljen"
                               @change="GetInfoKolikoJeOzancenih(profil.idProfil)">
                  </el-checkbox>
                </span>
                <span class="navadno-besedilo odmik-naziva">
                  {{profil.naziv}}
                </span>
              </div>
            </div>
          </div>
          <div style="padding-top: 30px" v-if="vklopljenOperaterskiRoamingProfil && kontaktniPodatki !== null">
              <i>
                <img :src="ikonaWarning" class="Icon-awesome"/>
              </i>
              <b>STATUS</b>: Nastavitev je zaklenjena zaradi preseženega limita ali drugih zlorab.
              Za več informacij pokličite {{ kontaktniPodatki.T2_SUPPORT_TEL_ST }}.
          </div>
        </div>
      </div>
      <div v-if="voiceFeaturesEnabled">
        <hr class="hr-stil">
        <div style="padding-top: 30px">
          <p class="open-sans-20pt">
            Zapore klicev
          </p>
        </div>
        <div style="padding-top: 30px">
          <p class="navadno-besedilo">
            Z vklopom onemogočite klice na izbrano možnost.
          </p>
        </div>
        <div style="clear: both; padding-top: 15px;" v-loading="jePridobivanjeZaporeKlicev">
          <div v-for="(zapore,index) in zaporeKlicevIzpis">
            <el-form label-width="400px" :label-position="formaOrientacija" v-if="index <= 4" class="custom-prikaz">
              <el-form-item :label=zapore.name>
                <el-radio-group v-model="zapore.active" v-if="typeof zapore.value === 'undefined'">
                  <el-radio :label="true">
                    Da
                  </el-radio>
                  <el-radio :label="false">
                    Ne
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <div v-if="typeof zapore.value !== 'undefined'" style="padding-top: 30px">
              <p class="navadno-besedilo">
                Zapore klicev lahko uporabnik nastavlja tudi preko mobilnega aparata, vendar mora poznati geslo.
                Če želite onemogočiti, da bi uporabnik številke sam spreminjal
                <br class="new-line"/> nastavitve, spremenite kodo.
                Zapore odhodnih klicev onemogočijo odhodne klice, zapore dohodnih pa dohodne, torej sprejemanje klicev.
              </p>
              <div style="padding-top: 30px">
                <el-form label-width="400px" :label-position="formaOrientacija">
                  <el-form-item class="normal-line" :label="zapore.name">
                    <el-input placeholder="Vnesite geslo" v-model="zapore.value"
                              class="velikost-inputa-koda-za-spremembo-zapore">
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <div class="postavitev-gumb">
          <el-button type="primary" @click="SpremebaZaporeKlicev(zaporeKlicevIzpis)"
                     class="gumb-potrdi">
            SHRANI SPREMEMBE
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {povezave} from '../../../../../../assets/js/Povezave/povezave'
import {Button, Select, Option, Input, Loading, MessageBox, Pagination} from 'element-ui'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {KontaktniPodatkiEnum} from '../../../../../../assets/js/Enum/KontaktniPodatkiEnum'

export default {
  name: 'Blokade',
  mixins: [PrikazVsebine],
  data () {
    return {
      clientAgent: null,
      formaOrientacija: 'left',
      nalaganjeZaporeKlicev: false,
      mejnaSirina: 1200,
      mobilnoGostovanje: '',
      nadzorPorabeMobilneTelefonije: '',
      vklopljenOperaterskiRoamingProfil: false,
      ikonaWarning: '/static/img/Domov/Icon-awesome-exclamation-triangle-black.png',
      kontaktniPodatki: null,
      seznamPodatkovZgodovineSporocil: [],
      dolzinaZgodovineKomercialnihSporocil: null,
      seznamZgodovineKomercialnihSporocil: []
    }
  },
  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Loading.name]: Loading,
    [Input.name]: Input,
    [Pagination.name]: Pagination
  },
  props: {
    izbranPrikljucek: String,
    izbranaTelefonska: String,
    zaporeKlicevIzpis: Array,
    mednarodnoPodatkovneBlokade: Array,
    nacionalnePodatkovneBlokade: Array,
    izbranaMednarodnoPodatkovneBlokade: Object,
    izbranaNacionalnaPodatkovnaBlokada: Object,
    jePridobivanjeZaporeKlicev: Boolean,
    jePridobivanjePodatkovneBlokade: Boolean,
    prenosniPodatkiKomercialnaSporocila: Object,
    seznamRoamingProfilov: Array,
    jeMobilniTopPaket: Boolean,
    voiceFeaturesEnabled: Boolean
  },
  watch: {
    prenosniPodatkiKomercialnaSporocila: function () {
      this.seznamZgodovineKomercialnihSporocil = []
      this.SetZgodovineKomercialnihSporocil()
    },
    orientacija: function (val) {
      this.formaOrientacija = val
    },
    seznamRoamingProfilov: function (seznam) {
      this.vklopljenOperaterskiRoamingProfil = false
      if (Array.isArray(seznam)) {
        for (let i = 0; i < seznam.length; i++) {
          if (seznam[i].vklopljenOperatersko) {
            this.vklopljenOperaterskiRoamingProfil = true
            return true
          }
        }
      }
    }
  },
  mounted () {
    this.kontaktniPodatki = KontaktniPodatkiEnum
    this.mobilnoGostovanje = povezave.BASE_URL_MOBILNO_GOSTOVANJE
    this.nadzorPorabeMobilneTelefonije = povezave.BASE_URL_NADZOR_PORABE_MOBILNE_TELEFONIJE
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.SetZgodovineKomercialnihSporocil()
  },
  methods: {
    SpremebaZaporeKlicev (spremebaStatusZaporeKlicev) {
      this.$emit('spremebaStatusZaporeKlicev', spremebaStatusZaporeKlicev)
    },
    SpremebaMednarodnoPodatkovneBlokade (spremembaStatusMednarodnaPodatkovnaBlokada) {
      this.$emit('spremebaMednarodnoPodatkovneBlokade', spremembaStatusMednarodnaPodatkovnaBlokada)
    },
    SpremebaNacionalnePodatkovneBlokade (spremebaStatusNacionalnePodatkovneBlokade) {
      this.$emit('spremebaNacionalnePodatkovneBlokade', spremebaStatusNacionalnePodatkovneBlokade)
    },
    NastaviBlokado () {
      this.$emit('nastaviBlokado')
    },
    OdstraniBlokado () {
      this.$emit('odstraniBlokado')
    },
    GetInfoKolikoJeOzancenih (idProfila) {
      MessageBox.confirm('Ali ste prepričani, da želite spremeniti omrežje v katerem želite uporabljati podatke?',
        'Opozorilo', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        this.$emit('spremembeRoamingProfili', idProfila)
      }).catch((err) => {
        err = null
        this.$emit('ponovnoNaloziRoamingProfile')
      })
    },
    SetZgodovineKomercialnihSporocil () {
      this.seznamZgodovineKomercialnihSporocil = []
      if (this.prenosniPodatkiKomercialnaSporocila.zgodovina !== undefined) {
        this.seznamZgodovineKomercialnihSporocil = this.prenosniPodatkiKomercialnaSporocila.zgodovina.reverse()
      }
      if (typeof this.seznamZgodovineKomercialnihSporocil !== 'undefined') {
        let tmpArray = []
        this.dolzinaZgodovineKomercialnihSporocil = this.seznamZgodovineKomercialnihSporocil.length
        const chunk = 4
        for (let i = 0; i < this.dolzinaZgodovineKomercialnihSporocil; i += chunk) {
          tmpArray.push(this.seznamZgodovineKomercialnihSporocil.slice(i, i + chunk))
        }
        this.seznamZgodovineKomercialnihSporocil = tmpArray
        this.PrikaziStranZgodovineKomercialnihSporocil(1)
      }
    },
    PrikaziStranZgodovineKomercialnihSporocil (stran) {
      if (typeof this.seznamZgodovineKomercialnihSporocil[stran - 1] !== 'undefined') {
        this.seznamPodatkovZgodovineSporocil = this.seznamZgodovineKomercialnihSporocil[stran - 1]
      } else {
        this.seznamPodatkovZgodovineSporocil = []
      }
    }
  }
}
</script>
<style scoped src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveMobilnaTelefonija/Blokade.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveMobilnaTelefonija/Blokade.vue